import React from "react";
import Checkbox from "@material-ui/core/Checkbox";

export const ReserveCheckbox = ({ checked, disabled, onChange }) => (
	<Checkbox
		checked={checked}
		onChange={onChange}
		disabled={disabled}
		color="primary"
		inputProps={{ "aria-label": "reserve checkbox" }}
	/>
);
